function noop() {
}
const createDefaultLogger = (title, loggingDisabled) => {
  if (loggingDisabled) {
    return {
      error: noop,
      info: noop,
      log: noop,
      success: noop,
      warn: noop
    };
  }
  const logStyles = {
    error: { bg: "#D63B1F", text: "#FFFFFF" },
    log: { bg: "#1565C0", text: "#FFFFFF" },
    success: { bg: "#47B882", text: "#143324" },
    warn: { bg: "#F9BA1B", text: "#453408" }
  };
  const createLogFn = (key) => (...args) => console.log(
    `%c ${title} `,
    `background: ${logStyles[key].bg}; color: ${logStyles[key].text}; padding: 4px; border-radius: 4px;`,
    ...args
  );
  return {
    error: createLogFn("error"),
    log: createLogFn("log"),
    success: createLogFn("success"),
    warn: createLogFn("warn")
  };
};
export {
  createDefaultLogger
};
//# sourceMappingURL=createDefaultLogger.js.map
